<template>
	<div class="class-making-box clearfix">
		<h3 class="f-18 text-nomal">수업계획표</h3>
		<div class="white-box clearfix">
			<p class="f-14 m-b-5">
				수업계획표 등록
			</p>
			<div class="input-group full-width">
				<span class="input-group-addon p-r-5">
					<div class="search-box full-width v-mid">
						<input id="file" type="file" style="display: none;" ref="fileRef" @change="upload">
						<input id="file-text" class="form-control-sm round full-width m-b-0" type="text" placeholder="파일명" v-model="lesPlanFileName" readonly>
					</div>
				</span>
				<span class="input-group-addon w120 p-r-5">
					<label for="file" class="btn-sm round full-width">업로드</label>
				</span>
				<span class="input-group-addon w200">
					<div class="input-group-addon text-left p-l-10 p-5 bg-white">
						<!-- <input id="check1" class="checkbox2" type="checkbox" @click="setLesPlanFileEmpty"> -->
						<!-- <label for="check1">강의계획서 삭제</label> -->
						<button class="btn-sm btn-red round" @click="setLesPlanFileEmpty">강의계획서 삭제</button>
					</div>
				</span>
			</div>
			<div v-if="progressShow"> 
				첨부파일 업로드 진행사항 <progress class="input-group-addon" max="100" :value.prop="progress" ></progress>
			</div>
		</div>

		<!-- button wrapper -->
		<!-- <button class="btn btn-red round m-t-30 pull-left" type="button" @click="setInitValue">초기값으로 설정</button> -->
		<button class="btn bg-deepblue text-white round m-t-30 pull-right" type="button" @click="nextStep">저장 하고 강좌 개설 완료하기</button>
	</div>
</template>

<script>
import axios from 'axios'
import server from '../../statics/server.js'

export default {
	name: "SubviewClassRegisterStep_8",
	data: function() {
		return {
			data: {
				lesPlanFile: this.classData.lesPlanFile || '',
				lesPlanNotExists: this.classData.lesPlanFile && this.classData.lesPlanFile.atchFileId || false
			},
			lesPlanFileName:  this.classData.lesPlanFile && this.classData.lesPlanFile.orignlFileNm || '',
			progressShow: false,
			progress: 0,
		}
	},
	props: {
		classData: Object,
		default: Object
	},
	methods: {
		setLesPlanFileEmpty: function() {
			this.data.lesPlanFile = '';
			this.data.lesPlanNotExists = true;
			this.lesPlanFileName = '';
		},
		setInitValue: function() {
			this.data.lesPlanFile = this.default.lesPlanFile;
			this.data.lesPlanNotExists = this.default.lesPlanFile.atchFileId || false
			this.lesPlanFileName = this.default.lesPlanFile.orignlFileNm;
		},
		upload: async function() {
			try {
			this.lesPlanFileName = "업로드하는 중..."
				const formData = new FormData();
				formData.append("file", this.$refs.fileRef.files[0]);
				this.progress = 0;
				this.progressShow = true;
				const { data } = await axios.post(`${server.addr()}${server.api.FILE}`, formData, {
					onUploadProgress: progressEvent => this.progress = parseInt(Math.round(( progressEvent.loaded / progressEvent.total ) * 100 ))
				});
				this.data.lesPlanFile = data;
				this.lesPlanFileName = this.$refs.fileRef.files[0].name;
				this.progressShow = false;
			} catch(e) {
				//TODO: error exception
			}
		},
		skipStep: function() {
			this.$emit("skipStep", {});
		},
		nextStep: function() {
			this.$emit("nextStep", this.data);
		}
	}
}
</script>

<style>

</style>